import React, { useState, useEffect, useCallback, useRef } from 'react';

const NotificationAlert = ({ user }) => {
    const [activeAlerts, setActiveAlerts] = useState([]);
    const [acknowledgedAlerts, setAcknowledgedAlerts] = useState(new Set());
    const lastCheckRef = useRef(0);

    const playAlertSound = useCallback(() => {
        try {
            const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
            const oscillator = audioCtx.createOscillator();
            const gainNode = audioCtx.createGain();

            oscillator.type = 'sine';
            oscillator.frequency.setValueAtTime(440, audioCtx.currentTime); // A4
            oscillator.frequency.exponentialRampToValueAtTime(880, audioCtx.currentTime + 0.1);

            gainNode.gain.setValueAtTime(0.1, audioCtx.currentTime);
            gainNode.gain.exponentialRampToValueAtTime(0.01, audioCtx.currentTime + 0.5);

            oscillator.connect(gainNode);
            gainNode.connect(audioCtx.destination);

            oscillator.start();
            oscillator.stop(audioCtx.currentTime + 0.5);
        } catch (e) {
            console.warn('Falha ao reproduzir som de alerta:', e);
        }
    }, []);

    const checkAlerts = useCallback(async () => {
        if (!user) return;

        try {
            const res = await fetch('/api/calendar/events', { credentials: 'include' });
            if (!res.ok) return;

            const events = await res.json();
            const now = new Date();

            const newAlerts = events.filter(e => {
                if (!e.alert_enabled || !e.alert_time) return false;
                if (acknowledgedAlerts.has(e.id)) return false;

                const alertTime = new Date(e.alert_time);
                // Alert if now is after alertTime but not older than 1 hour (to avoid spamming old alerts)
                return now >= alertTime && (now - alertTime) < 3600000;
            });

            if (newAlerts.length > activeAlerts.length) {
                setActiveAlerts(newAlerts);
                playAlertSound();
            }
        } catch (err) {
            console.error('Erro ao verificar alertas:', err);
        }
    }, [user, acknowledgedAlerts, activeAlerts.length, playAlertSound]);

    useEffect(() => {
        const interval = setInterval(checkAlerts, 30000); // Check every 30s
        checkAlerts(); // Initial check
        return () => clearInterval(interval);
    }, [checkAlerts]);

    const dismissAlert = (id) => {
        setAcknowledgedAlerts(prev => new Set([...prev, id]));
        setActiveAlerts(prev => prev.filter(a => a.id !== id));
    };

    if (activeAlerts.length === 0) return null;

    return (
        <div style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            gap: '10px'
        }}>
            {activeAlerts.map(alert => (
                <div key={alert.id} className="win-style" style={{
                    width: '300px',
                    background: '#fffbe6',
                    border: '3px solid #000',
                    boxShadow: '4px 4px 0 #000',
                    padding: '0'
                }}>
                    <div className="win-header" style={{ background: '#ffcc00', padding: '5px 10px', display: 'flex', justifyContent: 'space-between' }}>
                        <span>🔔 ALERTA DE COMPROMISSO</span>
                        <button onClick={() => dismissAlert(alert.id)} style={{ cursor: 'pointer' }}>X</button>
                    </div>
                    <div className="win-body" style={{ padding: '10px' }}>
                        <strong style={{ display: 'block' }}>{alert.title}</strong>
                        <p style={{ margin: '5px 0', fontSize: '0.9rem' }}>{alert.description}</p>
                        <small>{new Date(alert.start_date).toLocaleString('pt-BR')}</small>
                        <div style={{ marginTop: '10px', textAlign: 'right' }}>
                            <button className="btn-classic" onClick={() => dismissAlert(alert.id)}>OK, Entendido</button>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default NotificationAlert;
